// left hand navigation
jQuery('.sub-menu-close a').click(function(e) {
  e.preventDefault();

  jQuery('main.cd-main-content').removeClass('sidebar-open');
});

jQuery('.sub-menu-open').click(function(e) {
  e.preventDefault();

  jQuery('main.cd-main-content').toggleClass('sidebar-open');
});


// global nav
// When you click outside of the menu or menu button, close everything
jQuery("html").click(function(event) {
  
  var $trigger = jQuery("#header-content");

  if ($trigger !== event.target && !$trigger.has(event.target).length) {

    var $triggerAlt = jQuery("button.dol-menu-button");

    if ($triggerAlt[0] !== event.target && !$triggerAlt.has(event.target).length) {
      jQuery(".usa-mobile_nav-active").removeClass("usa-mobile_nav-active");
      jQuery(".usa-nav-link").attr("aria-expanded", function() {
        return "false";
      });
      jQuery(".usa-nav-submenu").attr("aria-hidden", function() {
        return "true";
      });
      var navItem = jQuery(".usa-nav-primary").find("> li > button");
      jQuery.each(navItem, function() {
        if (jQuery(this).hasClass("fa-chevron-left")) {
          jQuery(this).removeClass("fa-chevron-left");
          jQuery(this).addClass("fa-chevron-right");
        }
      });
      jQuery(".cd-primary-nav").find("> li").removeClass("menu-is-active menu-is-open");
      jQuery(".cd-primary-nav").find("> li > a").removeClass("selected");
      jQuery(".cd-primary-nav").find(".cd-secondary-nav").addClass("is-hidden");
      jQuery(".nav-container").removeClass("nav-is-open");
    }
  }
});

jQuery(".usa-button-primary").click(function(event) {

  if (jQuery(this).html() == "Menu") {
    jQuery("#header-content").css("margin-bottom", "2em");
  }else{
    jQuery("#header-content").css("margin-bottom", "0em");
  }
});

// new accordion functions
if(jQuery('.msha-grouped-accordion').length) {
  mshaGroupedAccordion();
} else {
  mshaAccordion()
}

function mshaGroupedAccordion() {
  jQuery('.msha-grouped-accordion').each(function() {
    jQuery(this).find('h3').each(function(index,item){
        jQuery('<div class="msha-accordion" id="group' + index + '"></div>').insertAfter(item);
        jQuery(item).nextUntil('h3').appendTo('#group'+index);
      });
  });
  mshaAccordion();
}

function mshaAccordion() {
  jQuery('.msha-accordion').each(function(i) {
    let thisParent = jQuery(this);
    let parentIndex = i;
  
    jQuery(this).find('.views-row').each(function(index) {
      let thisTitle = jQuery(this).find('.views-field-title .field-content').text();
      let thisBody = jQuery(this).find('.views-field-body .field-content').html();
      let thisIndex = index;
  
      thisParent.append('<h3 class="usa-accordion__heading"><button type="button" class="usa-accordion__button" aria-expanded="false" aria-controls="'+parentIndex+'-'+thisIndex+'">'+thisTitle+'</button></h3><div id="'+parentIndex+'-'+thisIndex+'" class="usa-accordion__content usa-prose">'+thisBody+'</div>');
  
      jQuery(this).remove();
    });
  
    thisParent.addClass('usa-accordion usa-accordion--bordered');
  });
}

jQuery(function() {
  // fatality counter
  const thisYear =  (new Date).getFullYear();

  jQuery('.fatality-count-container').each(function(){
    let count = 0;
    jQuery(this).find('.fatality-year').each(function(){
      let thisFatalityYear = jQuery(this).text().trim();
  
      if(thisFatalityYear.toString() == thisYear.toString()) {
        count++
      }
      jQuery(this).closest('.views-row').remove();
    });

    let thisLabel = count+" fatalities this year";
  
    if(count==1) {
      thisLabel = count+" fatality this year";
    }

    jQuery(this).append('<a href="/data-and-reports/fatality-reports/search" aria-label="'+thisLabel+' - Search Fatality Reports"><div class="count-inner"><span><div class="fatalities-to-date" aria-hidden="true">Fatalities this Year:</div><div class="fatality-count-total" aria-hidden="true">'+count+'</div></span></div></a>');
  });

  // left sidebar fix for nested ul
  jQuery('ul.usa-sidenav > li > ul > li a.is-active.usa-current').closest('ul.usa-sidenav').prev().addClass('is-active usa-current').closest('ul.usa-sidenav').prev().addClass('is-active usa-current');

  // training videos
  jQuery('.training-videos-container').each(function() {
    jQuery(this).find('.video-responsive').each(function(){
      let thisVideoID = jQuery(this).attr('data-video');
      let thisVideoTitle = jQuery(this).attr('video-title');
      jQuery(this).append('<iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0" src="https://www.youtube.com/embed/'+thisVideoID+'" title="'+thisVideoTitle+'"></iframe>')
    });
  });
});

function openAll() {
  var elements = document.querySelectorAll('.usa-accordion__content');
  elements.forEach(function(element) {
      element.removeAttribute('hidden');
      element.previousElementSibling.querySelector('button').setAttribute('aria-expanded', 'true');
  });
}

function closeAll() {
  var elements = document.querySelectorAll('.usa-accordion__content');
  elements.forEach(function(element) {
      element.setAttribute('hidden', '');
      element.previousElementSibling.querySelector('button').setAttribute('aria-expanded', 'false');
  });
}